import React, { useEffect } from 'react';
import { propsType } from './headAdminCreateClass';

interface placeType {
	place_name: string;
	road_address_name: string;
	address_name: string;
	phone: string;
	//place_url: string
}

const MapContainer = (props: propsType) => {
	return (
		<div className="map-container">
			<div id="map" className="map"></div>
			<div id="search-result">
				<p className="result-text">
					<span className="result-keyword">{props.searchKeyword}</span>
				</p>
				<div className="scroll-wrapper">
					<ul id="places-list"></ul>
				</div>
				<div id="pagination"></div>
			</div>
		</div>
	);
};

export default MapContainer;
